export const LayerType = {
    /**
     * 规划 101开始
     */
    LAMP: 101, // 路灯
    FENCE: 102, // 围墙
    GROUND: 103, // 地面
    PARKING_SPACE: 104,  // 机动车位&非机动车位
    TREES: 105, // 乔灌木


    /**
     * 建筑 201开始
     */
    AXIS_NET: 201, // 轴网
    WALL: 202, // 墙
    FLOOR: 203, // 楼板
    CEILING: 204, // 吊顶
    BEAM: 205, // 梁
    COLUMN: 206, // 柱
    DOOR: 207, // 门
    WINDOW: 208, // 窗
    HOLE: 209, // 洞口
    ELEVATOR_CAR: 210, // 轿厢
    STAIRWAY: 211, // 楼梯


    STATION: 212, // 站台
    ROOF_SLAB: 213, // 屋面板
    EAVES_BOARD: 214, // 檐口板
    GUTTER: 215, // 天沟

    ROAM_ROUTE_POINT: 221, // 路线点


    /**
     * 结构 301开始
     */
    JOINT: 301, // 节点
    SBEAM: 302, // 梁
    SCOLUMN: 303, // 柱
    SBAR: 304, // 杆
    SBRACE: 305, // 支撑
    SWALL: 306, // 墙
    SFLOOR: 307, // 板

    /**
     * 暖通 401开始
     */
    TUNNEL: 401, // 管道
    CONNECT: 402, // 接头
    VORTEXFAN: 403, // 旋涡风机
    EXHAUSTOPENING: 404, // 排风管
    SUPPRESSOR: 405, // 消音器
    ATTACHMENT: 406, // 配件

    /**
     * 给排水 501开始
     */

    /**
     * 电气 601开始
     */

    /**
     * 消防 701开始
     */
    FIRE_TUNNEL: 701, // 消防管道
    FIRE_SHUTTER: 702, // 防火卷帘
    SMOKE_TUNNEL: 703, // 排烟送风管道
    SMOKE_DETECTOR: 704, // 烟感器
    FIRE_HYDRANT: 705, // 消火栓
    FIRE_EXTINGUISHER: 706, // 灭火器
    SHOWER_NOZZLE: 707, // 淋喷头

    /**
     * 运维 801开始
     */
    PATROL_POINT: 801, // 巡更点
    Monitor: 808, // 巡检-摄像头

    ANEMOCLINOGRAPH: 802, // 风速风向仪
    FLUVIOGRAPH: 803, // 水位计
    CAMERA: 804, // 摄像头

    SERIAL: 805, // 串口设备
    DVR: 806, // 硬盘录像机
    CABLE: 807, // 数据线缆
}

export const LayerTypeList = [
    { value: 201, label: '轴网' },

    { value: 212, label: '站台' },
    { value: 213, label: '屋面板' },
    { value: 214, label: '檐口板' },
    { value: 215, label: '天沟' },

    { value: 221, label: '路线点' },
    { value: 403, label: '漩涡风机' },
    { value: 404, label: '排风口' },
    { value: 405, label: '消音器' },
    { value: 802, label: '风速风向仪' },
    { value: 803, label: '水位计' },
    { value: 804, label: '监测摄像头' },
    { value: 805, label: '串口设备' },
    { value: 806, label: '硬盘录像机' },
    { value: 807, label: '数据线缆' },

]

export function getLayerTypeName(layerType: number) {
    let label = LayerTypeList.find(item => item.value === layerType)?.label || null;
    return label
}